<div class="card mx-auto" style="max-width: 400px;">
    <div class="card-body playwrite-au-nsw">
      <h4>Reset Password</h4>
  
      <div class="mb-3">
        <label>Recovery Code</label>
        <input class="form-control" [(ngModel)]="code" name="code" />
      </div>
  
      <div class="mb-3">
        <label>New Password</label>
        <div class="input-group">
          <input
            [type]="showPassword ? 'text' : 'password'"
            class="form-control"
            [(ngModel)]="newPassword"
            name="newPassword"
          />
          <button class="btn btn-outline-secondary" (click)="toggleShowPassword()">
            {{ showPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
      </div>
  
      <button class="btn btn-primary" (click)="onReset()">Reset Password</button>
    </div>
  </div>
  